import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
	createCreditFromSalesReturn,
	deleteSalesReturn,
	fetchSalesReturnDetails,
} from '../../../../../services/sales_return';
import { generateSalesReturnPdf } from '../components/generateSalesReturnPdf';
import pdfMake from 'pdfmake/build/pdfmake';
import UseSalesReturn from './useSalesReturn';
import { useSelector } from 'react-redux';

const UseSalesReturnDetails = () => {
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const { handlePrintAndDownloadPdf } = UseSalesReturn();
	const suburl = localStorage.getItem('suburl');
	const [returnsDetails, setReturnDetails] = useState([]);
	const [updateStatus, setUpdateStatus] = useState(null);
	const [isUpdateStatusModelOpen, setUpdateStatusModelOpen] = useState(false);
	const [isDeleteModelOpen, setIsDeleteModalOpen] = useState(false);
	const [isCreateCreditNoteModelOpen, setIsCreateCreditNoteModalOpen] = useState(false);
	const [loader, setLoader] = useState({
		isLoading: false,
		status: null,
	});
	async function handleUpdateStatus() {
		try {
			toast.success('Status Updated Successfully');
			navigate(`/user/${suburl}/invoices`);
		} catch (error) {
			toast.error(error?.message ?? 'Sometning went wrong!');
		}
	}

	async function handleDeleteSalesReturn() {
		try {
			var body = JSON.stringify({
				ids: `[${id}]`,
			});
			await deleteSalesReturn(body);
			toast.success('Sales return delete successfully');
			navigate(`/user/${suburl}/sales-return`);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	}
	async function handleCreateCreditNote() {
		try {
			var body = {
				id: id,
			};
			await createCreditFromSalesReturn(body);
			toast.success('Credit Note created successfully');
			navigate(`/user/${suburl}/sales-return`);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	}

	async function generateSalesReturnsPdf(type = 'print', merge = false) {
		try {
			await handlePrintAndDownloadPdf(id, type, merge);
		} catch (error) {}
	}

	async function getSRDetails() {
		try {
			setLoader((prev) => ({
				...prev,
				isLoading: true,
				status: 'detail',
			}));
			const body = {
				ids: [id],
			};
			var { sales_return } = await fetchSalesReturnDetails(body);
			setReturnDetails(sales_return);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoading: false,
				loaderId: 'detail',
			}));
		}
	}
	useEffect(() => {
		if (id) {
			getSRDetails();
		}
	}, [id]);
	return {
		user,
		id,
		loader,
		suburl,
		navigate,
		returnsDetails,
		generateSalesReturnsPdf,
		handleDeleteSalesReturn,
		isDeleteModelOpen,
		setIsDeleteModalOpen,
		setUpdateStatus,
		setUpdateStatusModelOpen,
		isUpdateStatusModelOpen,
		setIsCreateCreditNoteModalOpen,
		isCreateCreditNoteModelOpen,
		handleCreateCreditNote,
		handleUpdateStatus,
		getSRDetails,
	};
};
export default UseSalesReturnDetails;
